import React from 'react';
import theme from '../../theme';
import { IconProps } from './props'

const CheckIcon: React.FC<IconProps> = ({ id, iconColor = theme.textDark, ...rest }) => (
    <svg
        id={id}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.547 6.05608C21.9375 6.4466 21.9375 7.07977 21.547 7.47029L10.547 18.4703C10.1564 18.8608 9.52326 18.8608 9.13274 18.4703L4.13274 13.4703C3.74221 13.0798 3.74221 12.4466 4.13274 12.0561C4.52326 11.6656 5.15643 11.6656 5.54695 12.0561L9.83984 16.349L20.1327 6.05608C20.5233 5.66555 21.1564 5.66555 21.547 6.05608Z"
            fill={iconColor}
        />
    </svg>
);

export { CheckIcon };